import { css } from '@emotion/css'
import { fontFamily } from '../../styles'
import getThemeColors, { colors } from '../../themes'

const styles = {
  link: css({
    fontFamily: fontFamily.body,
    fontSize: 'inherit',
    fontWeight: 'inherit',
    cursor: 'pointer',
    userSelect: 'none',
    textDecoration: 'none',

    '&:focus': {
      outline: 'none',
      textDecoration: 'underline',
    },

    '&:hover': {
      textDecoration: 'underline',
    },

    '&:active': {
      textDecoration: 'underline',
    },
  }),

  disabled: css({
    pointerEvents: 'none',
    cursor: 'default',
    opacity: 0.3,
  }),
}

export default styles

export const linkTheme = theme => {
  const themed = getThemeColors(theme)

  // The light theme is a special case
  if (theme === 'light') {
    return css({
      color: colors.jumbo,

      '&:active': {
        color: themed.dark,
      },
    })
  }

  return css({
    color: themed.base,

    '&:active': {
      color: themed.dark,
    },
  })
}
